function concatId(...ids) {
  return ids.join("_");
}
function splitLanguage(key) {
  const [lang, dialect = ""] = key.replace("_", "-").split("-");
  return {
    lang: lang.toLowerCase(),
    dialect: dialect.toLowerCase()
  };
}
export {
  concatId as c,
  splitLanguage as s
};
//# sourceMappingURL=helpers.js.map
